import type {
    OfferRequestSegment,
    PartnerCockpitOfferRequestsPage,
} from '@houzy/schemas/partner-cockpit/offer-requests';
import {
    keepPreviousData,
    queryOptions,
    useQuery,
    type UseQueryOptions,
    type UseQueryResult,
} from '@tanstack/react-query';

import { EMPTY_OFFER_REQUEST_FILTERS, OfferRequestSortKey } from '../types';
import { fetchOfferRequests, type OfferRequestsQueryParams } from './offerRequestsListApi';

export function defaultOfferRequestsQuery(segment: OfferRequestSegment): OfferRequestsQueryParams {
    return {
        segment,
        start: 0,
        pageSize: 10,
        sort: OfferRequestSortKey.Newest,
        filters: EMPTY_OFFER_REQUEST_FILTERS,
    };
}

// Prefix shared by every page of a segment, so a lead moving between screens can invalidate both wholesale.
export function offerRequestsSegmentKey(segment: OfferRequestSegment): readonly ['offerRequests', OfferRequestSegment] {
    return ['offerRequests', segment] as const;
}

type OfferRequestsQueryKey = readonly ['offerRequests', OfferRequestSegment, OfferRequestsQueryParams];

export function offerRequestsQueryOptions(
    query: OfferRequestsQueryParams,
): UseQueryOptions<PartnerCockpitOfferRequestsPage, Error, PartnerCockpitOfferRequestsPage, OfferRequestsQueryKey> {
    return queryOptions({
        queryKey: [...offerRequestsSegmentKey(query.segment), query] as const,
        queryFn: ({ signal }) => fetchOfferRequests(query, signal),
        placeholderData: keepPreviousData,
    });
}

export function useOfferRequestsList(query: OfferRequestsQueryParams): UseQueryResult<PartnerCockpitOfferRequestsPage> {
    return useQuery(offerRequestsQueryOptions(query));
}
